import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

/**
 * Presentational picker for a stored privacy perimeter: a button that starts the location
 * lookup, a status message beside it (pending / set / error), and a control to clear a
 * perimeter once one is stored.
 *
 * Running the location lookup, deciding what counts as "set", and picking the message text
 * for a given state are the host's job — this component only renders the flags and the
 * already-translated text it is handed, and reports back which action the user picked.
 */
@Component({
    selector: 'pace-privacy-perimeter-picker',
    imports: [FaIconComponent],
    templateUrl: './pace-privacy-perimeter-picker.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PacePrivacyPerimeterPickerComponent {
    /** whether a perimeter is currently stored */
    public readonly isSet = input(false);
    /** whether a location lookup is in flight */
    public readonly isPending = input(false);
    /** false disables the select button and hides the clear control, e.g. while the feature is off */
    public readonly editable = input(true);
    /** already-translated text for the select button */
    public readonly selectLabel = input('');
    /** already-translated text shown while a lookup is in flight */
    public readonly pendingLabel = input('');
    /** already-translated text shown once a perimeter is set and no lookup is running */
    public readonly setLabel = input('');
    /** already-translated error text; the error line is hidden while this is empty */
    public readonly errorText = input('');
    /** accessible name for the clear control, since it carries only an icon */
    public readonly clearAriaLabel = input('Clear location');

    public readonly perimeterRequested = output<void>();
    public readonly perimeterCleared = output<void>();

    public readonly faTimes = faTimes;
}
